import { useState, useCallback } from 'react';

// === UTILIDADES ===
const log = (...args) => {
  if (process.env.NODE_ENV === 'development') {
    console.log(...args);
  }
};

// === HOOK PERSONALIZADO: Carga de datos en memoria ===
export const useCargaDatosTurnoDetalleInMemory = (isOpenProp, turnoSeleccionadoProp, selectedProject, getDocumentosRegistradosByTurnoApi, fetchDietasActivas, setCantidadComensales) => {
    
  const [memoryDataLoaded, setMemoryDataLoaded] = useState({ loadStateDocumentosComedor: false, loadStateDietasComensal: false });
  const [documentosComedorInMemory, setDocumentosComedorInMemory] = useState(new Set());
  const [dietasComensalesInMemory, setDietasComensalesInMemory] = useState(new Map());
    
  const isLoading = memoryDataLoaded.loadStateDocumentosComedor === false || memoryDataLoaded.loadStateDietasComensal === false;

  const loadDocumentosComedorByTurnoDetalleInMemory = useCallback(async () => {
    const startTime = performance.now();
    log('INICIANDO carga de documentos de documentos comedor registrados en el Turno Detalle en memoria...');
    try {
      const response = await getDocumentosRegistradosByTurnoApi(turnoSeleccionadoProp.id);
      const documentos = response.data || [];
      
      // ✅ CORRECCIÓN: El API devuelve array de strings directamente, no objetos
      // Los documentos ya son los números de documento directamente
      const documentosSet = new Set(documentos);
      
      setDocumentosComedorInMemory(documentosSet);

      log('📊 Comensales en Turno Detalle - Tiempo de carga:', (performance.now() - startTime).toFixed(2) + 'ms');
      log('📈 Comensales en Turno Detalle - Cantidad de registros:', documentos.length);      

      // 🔢 ACTUALIZAR CANTIDAD INICIAL: Establecer la cantidad de comensales ya registrados
      if (setCantidadComensales) {
        setCantidadComensales(documentos.length);
      }

      setMemoryDataLoaded(prev => ({ ...prev, loadStateDocumentosComedor: true }));
    } catch (error) {
      log('❌ ERROR en carga de documentos registrados en memoria:', error);
      setMemoryDataLoaded(prev => ({ ...prev, loadStateDocumentosComedor: true })); 
    }
  }, [turnoSeleccionadoProp?.id, getDocumentosRegistradosByTurnoApi, setCantidadComensales]);

  // Función para cargar dietas de comensales en memoria
  const loadDietasComensalesInMemory = useCallback(async () => {
    const startTime = performance.now();
    log('INICIANDO carga de dietas de comensales en memoria...');

    try {
      // Usar el hook para obtener las dietas activas filtradas por proyecto
      const filtros = {
        id_proyecto: selectedProject?.id
      };
      log('🔍 Filtros aplicados para dietas:', filtros);

      const data = await fetchDietasActivas(filtros);
      
      // Convertir array a Map para búsquedas O(1) por numero_documento_comedor
      const dietasMap = new Map();
      if (data.dietas) {
        data.dietas.forEach(dieta => {
          dietasMap.set(dieta.numero_documento_comedor, {
            tipo_dieta: {
              nombre: dieta.tipo_dieta_nombre
            }
          });
        });
      }
      
      setDietasComensalesInMemory(dietasMap);

      log('📊 Dietas Comensales - Tiempo de carga:', (performance.now() - startTime).toFixed(2) + 'ms');
      log('📈 Dietas Comensales - Cantidad de registros:', dietasMap.size);

      
      setMemoryDataLoaded(prev => ({ ...prev, loadStateDietasComensal: true }));

    } catch (error) {
      log('❌ ERROR en carga de dietas de comensales en memoria:', error);      
      setMemoryDataLoaded(prev => ({ ...prev, loadStateDietasComensal: true })); // Marcar como completado también en error
    }
  }, [selectedProject?.id, fetchDietasActivas]);

  // Función principal para cargar todos los datos en memoria de manera secuencial
  const loadDatosInMemory = useCallback(async () => {    
    log('🎉 Inicio de carga de datos en memoria en secuencia');

    // Limpiar memoria anterior
    setDocumentosComedorInMemory(new Set());
    setDietasComensalesInMemory(new Map());
    
    setMemoryDataLoaded({ loadStateDocumentosComedor: false, loadStateDietasComensal : false });

    try {
      // Cargar ambos conjuntos de datos en paralelo
      await loadDocumentosComedorByTurnoDetalleInMemory();
      log('🎉 Carga de documentos comedor en memoria completada.');
      await loadDietasComensalesInMemory();
      log('🎉 Carga de dietas comensales en memoria completada.');

      log('🎉 Carga de datos en memoria completada.');

    } catch (err) {
      log('❌ Error en carga de datos en memoria:', err);
    }
  }, [loadDocumentosComedorByTurnoDetalleInMemory, loadDietasComensalesInMemory]);

  return {
    isLoading, 
    memoryDataLoaded,
    documentosComedorInMemory,
    setDocumentosComedorInMemory,
    dietasComensalesInMemory,
    setDietasComensalesInMemory,
    loadDatosInMemory
  };
};

export default useCargaDatosTurnoDetalleInMemory;